import Helmet from 'react-helmet'
import React from 'react'
import { helmetJsonLdProp } from 'react-schemaorg'

export const contactPoint = {
    bordeaux: {
        streetAddress: '24 Rue Rolland',
        postalCode: '33300',
        addressLocality: 'Bordeaux',
        addressCountry: 'fr',
        telephone: '+33 (0)5 56 23 26 31',
        email: 'michael@urbanlinker.com',
    },
    paris: {
        streetAddress: '12 rue du Sentier',
        postalCode: '75002',
        addressLocality: 'Paris',
        addressCountry: 'fr',
        telephone: '+33 (0)1 77 37 23 90',
        email: 'contact@urbanlinker.com',
    },
    lyon: {
        streetAddress: '7 Pass. Panama',
        postalCode: '69002',
        addressLocality: 'Lyon',
        addressCountry: 'fr',
        telephone: '+33 (0)4 78 05 90 15',
        email: 'contact@urbanlinker.com',
    },
}

export function OrganizationJsonLd() {
    return (
        <Helmet
            script={[
                helmetJsonLdProp({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: 'Urban Linker',
                    url: window._app_url,
                    contactPoint: [
                        {
                            '@type': 'ContactPoint',
                            areaServed: {
                                '@type': 'Place',
                                address: {
                                    '@type': 'PostalAddress',
                                    streetAddress: contactPoint.bordeaux.streetAddress,
                                    postalCode: contactPoint.bordeaux.postalCode,
                                    addressLocality: contactPoint.bordeaux.addressLocality,
                                    addressCountry: contactPoint.bordeaux.addressCountry,
                                }
                            },
                            telephone: contactPoint.bordeaux.telephone,
                            email: contactPoint.bordeaux.email,
                        },
                        {
                            '@type': 'ContactPoint',
                            areaServed: {
                                '@type': 'Place',
                                address: {
                                    '@type': 'PostalAddress',
                                    streetAddress: contactPoint.paris.streetAddress,
                                    postalCode: contactPoint.paris.postalCode,
                                    addressLocality: contactPoint.paris.addressLocality,
                                    addressCountry: contactPoint.paris.addressCountry,
                                }
                            },
                            telephone: contactPoint.paris.telephone,
                            email: contactPoint.paris.email,
                        },
                        {
                            '@type': 'ContactPoint',
                            areaServed: {
                                '@type': 'Place',
                                address: {
                                    '@type': 'PostalAddress',
                                    streetAddress: contactPoint.lyon.streetAddress,
                                    postalCode: contactPoint.lyon.postalCode,
                                    addressLocality: contactPoint.lyon.addressLocality,
                                    addressCountry: contactPoint.lyon.addressCountry,
                                }
                            },
                            telephone: contactPoint.lyon.telephone,
                            email: contactPoint.lyon.email,
                        }
                    ]
                }),
            ]}
        />
    )
}
